import Route from '@ember/routing/route';

export default class AgentsRoute extends Route {
	override beforeModel(): void {
		document.body.id = 'page-agents';
	}
}
